<template>
  <div class="particle-box-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>E_n = n²h² / (8mL²) | 能量量子化$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Box Walls -->
          <line x1="100" y1="40" x2="100" y2="200" stroke="#fff" stroke-width="4" />
          <line x1="300" y1="40" x2="300" y2="200" stroke="#fff" stroke-width="4" />
          
          <!-- Probability Density |ψ|² -->
          <path :d="probPath" fill="rgba(0, 210, 255, 0.2)" stroke="#00d2ff" stroke-width="2" />
          
          <!-- Cloud of particles based on |ψ|² -->
          <circle v-for="p in cloud" :key="p.id" :cx="p.x" :cy="p.y" r="1.5" fill="#00d2ff" :opacity="p.o" />

          <text x="180" y="220" fill="#888" font-size="8">势阱宽度 L</text>
          <text x="110" y="60" fill="#00d2ff" font-size="10">n = {{ n }} (能级)</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>能量 E ∝ {{ n * n }} E₁</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>选择量子数 n</label>
             <el-radio-group v-model="n" size="mini">
                <el-radio-button :label="1">n=1</el-radio-button>
                <el-radio-button :label="2">n=2</el-radio-button>
                <el-radio-button :label="3">n=3</el-radio-button>
                <el-radio-button :label="4">n=4</el-radio-button>
             </el-radio-group>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>“无限深势阱”是量子力学最经典的理想模型。当一个微观粒子被限制在有限的空间 L 内时，其波函数必须在边界处为零（形成驻波）。这导致粒子的动能不再是连续的，而是只能取分立的具体值，即**能量量子化**。n=1 是基态，能量最低；随着 n 增加，波函数的节点数也会增加。这是理解原子结构中电子占据特定“轨道”的初步物理图像。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ParticleBoxViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      n: 1,
      cloud: []
    }
  },
  computed: {
    probPath() {
       let points = [];
       // sin(n * pi * x / L)^2
       for (let i = 0; i <= 200; i += 2) {
          let x = 100 + i;
          let val = Math.pow(Math.sin((this.n * Math.PI * i) / 200), 2);
          let y = 180 - val * 100;
          points.push(`${x},${y}`);
       }
       return "M 100,180 " + points.join(" L ") + " L 300,180 Z";
    }
  },
  methods: {
    generateCloud() {
       this.cloud = [];
       for (let i = 0; i < 150; i++) {
          let x_idx = Math.random() * 200;
          let prob = Math.pow(Math.sin((this.n * Math.PI * x_idx) / 200), 2);
          if (Math.random() < prob) {
             this.cloud.push({
                id: i,
                x: 100 + x_idx,
                y: 190 + (Math.random() - 0.5) * 20,
                o: 0.3 + Math.random() * 0.7
             });
          }
       }
    }
  },
  watch: {
    n() { this.generateCloud(); }
  },
  mounted() { this.generateCloud(); }
}
</script>

<style scoped lang="scss">
.particle-box-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.02); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
